module.exports = __webpack_public_path__ + "static/media/faqBalance-en-fr.2e3b611c.vtt";